import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  Typography,
  Chip,
  Container,
  Grid,
  Card,
  Box,
  Button,
} from "@mui/material";
import Map from "../extra/Map";
import { SYSTEMINFO } from "../../services/actions";
import SystemStatsCharts from "./SystemStatsCharts";


export default function Dashboard() {
  const dispatch = useDispatch();
  let user = useSelector((state) => state?.loginState?.auth)
  const systemInfoState = useSelector((state) => state.systeminfoState)

  useEffect(() => {
    dispatch({ type: `${SYSTEMINFO}_GET`, payload: 0 });
  }, [dispatch]);

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <h1> System Resource Usage</h1>
      <SystemStatsCharts data={systemInfoState?.data} />
      <Grid container spacing={2} mt={2}>
        {systemInfoState?.data &&
          <Grid size={{ xs: 12, md: 12 }}>
            <Card
              sx={{
                p: 2,
                borderRadius: 8,
                boxShadow: 0,
              }}
            >
              <Box display={'flex'} gap={2} alignItems={'center'}>
                <Typography variant="h6">RAM</Typography>
                <Typography fontSize={12}>Total {systemInfoState?.data?.ram?.Mem?.total}</Typography>
                <Typography fontSize={12}>Used {systemInfoState?.data?.ram?.Mem?.used}</Typography>
                <Typography fontSize={12}>Available {systemInfoState?.data?.ram?.Mem?.available}</Typography>
              </Box>

              <Box sx={{ pt: 2, overflowX:'auto'}}>
                <Typography variant="h6">DISK SPACE</Typography>
                <table border="1" maxWidth="50%" style={{ borderCollapse: 'collapse' }}>
                  {(systemInfoState?.data?.disk_space || []).map((data, i) => <>

                    {i == 0 && <tr>
                      {Object.keys(data).map((key) => <th >{key}</th>)}
                    </tr >}
                    <tr >
                      {Object.keys(data).map((key) => <td style={{ paddingLeft: 10 }}>{data[key]}</td>)}
                    </tr >
                  </>
                  )}
                </table>
              </Box>
            </Card>
          </Grid>}
      </Grid>
    </Container >
  );
}
